import {observable, action, computed} from 'mobx';
import axiosInstance from '~/utils/axiosInstance';
import uris from '~/uris';
import {getLocaleStr} from '~/components/Alarm/utils';

declare module 'axios' {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  export interface AxiosRequestConfig {
    skipGlobalHandler?: boolean;
  }
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  export interface AxiosResponseConfig {
    data?: any;
  }
}
export class AlarmStore {
  @observable activeAlarms = [];

  @observable popupQueue = [];

  @observable delayQueue = [];

  @observable currentPopupAlert = null;

  @observable siteAlarmCnt = {};

  @computed get shouldPlaySound(): boolean {
    return this.activeAlarms.find(alert => alert.soundPromptOptional);
  }

  @computed get activeAlarmsHasSite(): object {
    const stAlarmMap = {};
    this.activeAlarms.forEach((alarm) => {
      const siteTypeName = alarm.mdmTypeInfo.type === 'Site' ? getLocaleStr(alarm?.mdmTypeInfo?.mdmTypeName)
        : getLocaleStr(alarm?.relatedMdm?.Site?.typeInfo?.mdmTypeName);
      if (siteTypeName) {
        if (stAlarmMap[siteTypeName]) {
          stAlarmMap[siteTypeName]++;
        } else {
          stAlarmMap[siteTypeName] = 1;
        }
      }
    });
    return stAlarmMap;
  }

  @action.bound
  getNewPopup(): any {
    return this.popupQueue.shift();
  }

  @action.bound
  enqueuePopup(): void {
    this.popupQueue.push({});
  }

  @action.bound
  searchAlert(): any {
    return axiosInstance
      .post(uris.searchAlert(), {
      }, {baseURL: ''})
      .then(action((data) => {
        this.activeAlarms = data as any;
        this.popupQueue = [];
        this.activeAlarms.forEach((alert) => {
          if (alert?.popup?.alertPopupOptional && alert?.popup?.style === 'WINDOWS') {
            this.popupQueue.push(JSON.parse(JSON.stringify(alert)));
          }
        });
      }));
  }

  @action.bound
  ackAlert(alertId): any {
    return axiosInstance
      .post(uris.ackAlert(), {
        alertId
      }, {baseURL: ''})
      .then(action((data) => {
        console.log(data);
      }));
  }

  @action.bound
  setCurrentPopupAlert(alert): any {
    this.currentPopupAlert = alert;
  }
}

export default new AlarmStore();
